/* Pronoia audio — imperial success cue for reframe completion.
   A short, uplifting 3-note fanfare (perfect 4th → 5th → octave)
   with a golden brass timbre.  Zero-cost Web Audio synth. */
import { getAudioCtx } from './audioCore';


let _ctx = null;
const getCtx = () => {
  if (typeof window === 'undefined') return null;
  _ctx = getAudioCtx();
  return _ctx;
};

const scheduleNote = (ctx, freq, startAt, dur = 0.35, peak = 0.14) => {
  // Layered: sine fundamental + gentle triangle 5th harmonic for warmth
  const osc1 = ctx.createOscillator();
  const osc2 = ctx.createOscillator();
  const g = ctx.createGain();
  osc1.type = 'sine';   osc1.frequency.value = freq;
  osc2.type = 'triangle'; osc2.frequency.value = freq * 2;
  g.gain.setValueAtTime(0.0001, startAt);
  g.gain.exponentialRampToValueAtTime(peak, startAt + 0.03);
  g.gain.exponentialRampToValueAtTime(peak * 0.6, startAt + dur * 0.4);
  g.gain.exponentialRampToValueAtTime(0.0001, startAt + dur);
  osc1.connect(g); osc2.connect(g); g.connect(ctx.destination);
  osc1.start(startAt); osc2.start(startAt);
  osc1.stop(startAt + dur + 0.05); osc2.stop(startAt + dur + 0.05);
};

/** Imperial success — 3-note upward fanfare. Played after Reframe completes. */
export const imperialSuccessCue = () => {
  const ctx = getCtx();
  if (!ctx) return;
  try { ctx.resume?.(); } catch { /* noop */ }
  const t = ctx.currentTime + 0.05;
  // C5 → G5 → C6 (root → 5th → octave) — classical triumph
  scheduleNote(ctx, 523.25, t + 0.00, 0.30, 0.12);
  scheduleNote(ctx, 783.99, t + 0.18, 0.35, 0.14);
  scheduleNote(ctx, 1046.5, t + 0.42, 0.55, 0.18);
};

/** Gentle notification chime — used when a new conspiracy is logged. */
export const conspiracyLoggedCue = () => {
  const ctx = getCtx();
  if (!ctx) return;
  try { ctx.resume?.(); } catch { /* noop */ }
  const t = ctx.currentTime + 0.05;
  // Two notes: C5 → E5 (major 3rd) — bright & affirming
  scheduleNote(ctx, 523.25, t + 0.00, 0.22, 0.10);
  scheduleNote(ctx, 659.25, t + 0.14, 0.32, 0.13);
};
